module.exports = __webpack_public_path__ + "img/advantage-2.66c27a43.png";